import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

const menuLinkStyles = css<{ color: string }>`
  text-decoration: none;
  font-weight: 600;
  color: ${({ color }) => color};
  text-align: center;
  opacity: 1;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;

export const StyledMenuLink = styled.a<{ color: string }>`
  ${menuLinkStyles}
`;

/** Same look as StyledMenuLink, but navigates to another page instead of an anchor. */
export const StyledMenuRouterLink = styled(Link)<{ color: string }>`
  ${menuLinkStyles}
`;
